import {
	LabelPosition,
	RHookFormNumberFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface ITD1ProvincialsSetupFieldsPanel {}
export const TD1ProvincialsSetupFieldsPanel: FC<
	ITD1ProvincialsSetupFieldsPanel
> = ({}) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				id={"basicPersonalAmountTd1Provisionals"}
				label="Basic Personal Amount"
				testId="Basic-Personal-Amount"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
